import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import EcoSection from 'eco-design/base/eco-section';
import EcoSpace from 'eco-design/base/eco-space';
import React, { useEffect, useState } from 'react';
import { getIconList } from './config';
import styles from './index.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import EcoImg from 'eco-design/base/eco-img';
import { solarPowerTran } from './textLang';
import { getIsMobileWidth2 } from '@elem/utils/devices';

interface Props {
    pageType: string;
}

const SolarPower: React.FC<Props> = ({ pageType }) => {
    const { locale = 'eu' } = getLocal();
    const [items, setItems] = useState<any>([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [loadKey, setLoadKey] = useState(1);
    const { t } = useLang('theProduct.SolarPower');
    const [swiperA, setSwiperA] = useState<any>(null); // 用于点击tab时执行轮播切换
    const isMobile = getIsMobileWidth2();

    let solar_label = t('solar_label');
    if (pageType === 'normal') {
        solar_label = t('seris_solar_label') || t('solar_label');
    }

    let solar_title = t('solor_title');
    if (pageType === 'normal') {
        solar_title = t('seris_solar_title') || t('solor_title');
    }

    const sectionItems = [
        {
            desc: t('item1_introduce_desc'),
            labelIsImg: true,
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745831331433/eu1.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745831331433/eu1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1747031003703/1-h5.jpg',
            tabLabel: t('item1_tabLabel'),
            tabValue: 'a',
            title: t('item1_introduce_title'),
            note: solarPowerTran[locale]['a_notes'],
        },
        {
            desc: t('item2_introduce_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745831331707/eu2.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745831331707/eu2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1747031003339/2-h5.jpg',
            tabLabel: t('item2_tabLabel'),
            tabValue: 'b',
            title: t('item2_introduce_title'),
            note: solarPowerTran[locale]['b_notes'],
        },
        {
            desc: t('item3_introduce_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745831381381/eu3.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745831381381/eu3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1747031003501/3-h5.jpg',
            tabLabel: t('item3_tabLabel'),
            tabValue: 'c',
            title: t('item3_introduce_title'),
            note: solarPowerTran[locale]['c_notes'],
        },
        {
            desc: t('item4_introduce_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745831332053/eu4.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745831332053/eu4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1747031003903/4-h5.jpg',
            tabLabel: t('item4_tabLabel'),
            tabValue: 'd',
            title: t('item4_introduce_title'),
            note: solarPowerTran[locale]['d_notes'],
        },
    ];

    const handleTabClick = (index: number) => {
        console.log(index);

        setCurrentIndex(index);
        swiperA.slideToLoop(index);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: t('solor_title'),
            button_name: sectionItems[index].tabLabel,
        });
    };

    const handleSlideChange = (swiper: any) => {
        const index = swiper.realIndex; //下标
        setCurrentIndex(index);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth >= 768 && window.innerWidth < 1024) {
                const newItems = sectionItems.map((item, index) => {
                    return {
                        ...item,
                        h5: item.pc,
                    };
                });
                setLoadKey(loadKey + 1);
                setItems([...newItems]);
            } else {
                setLoadKey(loadKey + 1);
                setItems([...sectionItems]);
            }
        }
    }, []);
    return (
        <section className={`${styles.SolarPower} GtmModuleData-section`} data-section-id="SolarPower" data-section-title={t('solor_label')}>
            <EcoSpace hPc="160px" hPad="100px" />
            <div className="head-label">{solar_label}</div>
            <EcoSection subTitle={t('solor_subtitle')} title={solar_title} className="section-text product-section" />
            {/* <EcoTabSectionLR items={items} key={loadKey} onChange={(item: any, index: number) => handleTabClick(index)} /> */}

            <div className="solar-swiper">
                <Swiper
                    slidesPerView={'auto'}
                    spaceBetween={isMobile ? 16 : 40}
                    pagination={{
                        clickable: true,
                    }}
                    modules={[Pagination]}
                    onSlideChange={handleSlideChange}
                    onSwiper={(swiperIns: any) => setSwiperA(swiperIns)}
                >
                    {sectionItems.map((item, index) => {
                        return (
                            <SwiperSlide key={item.title}>
                                <div className="solar-swiper__item">
                                    <EcoImg pc={item.pc} pad={item.pad} h5={item.h5} isOpenLazy />
                                    <div className="r-wrapper">
                                        <div>
                                            <div className="title">{item.title}</div>
                                            <div className="desc">{item.desc}</div>
                                            <div className="icons">
                                                {getIconList(locale, item.tabValue).map((item) => {
                                                    return (
                                                        <span key={item.name} className="icon__item">
                                                            {item.icon()}
                                                        </span>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                        <div className="note">{item.note}</div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>

            <div className="swiper-tabs">
                {sectionItems.map((item, index) => {
                    return (
                        <div key={item.title} className={'swiper-tabs__item ' + (currentIndex === index ? 'active' : '')} onClick={() => handleTabClick(index)}>
                            {item.tabLabel}
                        </div>
                    );
                })}
            </div>

            <EcoSpace hPc="160px" hPad="100px" />
        </section>
    );
};

export default SolarPower;
